<template>
  <v-card :key="componentKey" flat color="transparent" :style="`color:${textColor(item.rarity)}; margin-left:0px!important; margin-right:0px!important;`" :img="require(`../assets/${backColor(item.rarity)}`)">
    <v-img class="cardback" contain>
      <v-card-title v-if="item.uiType" class="headline"  :style="`color:white; justify-content:center; margin-top;border-width:thick; border-style:ridged; border-color:${borderColor(item)}; word-break:break-word`">
        <v-spacer v-if="['feats','perks','weapon'].includes(item.uiType)" style="margin-left:34px"/>
        <v-spacer v-if="['maneuver','spells'].includes(item.uiType)" style="margin-left:50px"/>
        <v-spacer v-if="item.uiType == 'wonderousItems' && character"></v-spacer>
        {{ item.name }}
        <!-- <v-checkbox v-model="simpleExplanation">simple</v-checkbox> -->
        <v-spacer v-if="item.uiType == 'weapon'" ></v-spacer>
        <v-spacer v-if="item.uiType == 'wonderousItems' && character"></v-spacer>
        <v-spacer v-if="['maneuver','spells','feats','perks'].includes(item.uiType)"/>
        <v-icon v-if="item.uiType == 'weapon' && character" @click="weaponModifiers = true" xs dense color="grey">settings</v-icon>

        <span v-if="character">
          <v-tooltip v-if="['maneuver','spells'].includes(item.uiType) && !item.expended" top max-width="500" open-delay="500">
            <template v-slot:activator="{ on, attrs }">
              <v-icon @click="toggleReady()" v-bind="attrs" v-on="on" style="padding-right:2px" size="1.2em" dense color="red">mdi-alpha-e-circle</v-icon>
            </template>
            <span style="white-space: pre-wrap; max-width:400px">Expend (Shift+Click)</span>
          </v-tooltip>

          <v-tooltip v-if="['maneuver','spells'].includes(item.uiType) && item.expended" top max-width="500" open-delay="500">
            <template v-slot:activator="{ on, attrs }">
              <v-icon @click="toggleReady()" v-bind="attrs" v-on="on" style="padding-right:2px" size="1.2em" dense color="green">mdi-alpha-r-circle</v-icon>
            </template>
            <span style="white-space: pre-wrap; max-width:400px">Recover (Shift+Click)</span>
          </v-tooltip>

          <v-tooltip v-if="['maneuver','spells'].includes(item.uiType) && !item.favorite" top max-width="500" open-delay="500">
            <template v-slot:activator="{ on, attrs }">
              <v-icon @click="toggleFavorite()" v-bind="attrs" v-on="on" style="padding-right:4px" size="1.2em" dense color="black">mdi-star-circle</v-icon>
            </template>
            <span style="white-space: pre-wrap; max-width:400px">Favorite (Ctrl+Click)</span>
          </v-tooltip>

          <v-tooltip v-if="['maneuver','spells'].includes(item.uiType) && item.favorite" top max-width="500" open-delay="500">
            <template v-slot:activator="{ on, attrs }">
              <v-icon @click="toggleFavorite()" v-bind="attrs" v-on="on" style="padding-right:4px;" size="1.2em" dense color="yellow">mdi-star-circle</v-icon>
            </template>
            <span style="white-space: pre-wrap; max-width:400px">Unfavorite (Ctrl+Click)</span>
          </v-tooltip>
        </span>
        <v-tooltip v-if="item.additionalInfo || item.additionalInfoTags" bottom max-width="500">
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" :style="`color:${textColor(item.rarity)};padding-bottom:2px`">help_outline</v-icon>
          </template>
          <span style="white-space: pre-wrap; max-width:400px">{{setAdditionalInfo()}}</span>
        </v-tooltip>
        <v-icon v-if="['maneuver','spells','feats','perks'].includes(item.uiType) && character && (!item.hidden || item.hidden && item.hidden==false)" @click="toggleHide()" size="1.1em" dense color="grey">visibility_off</v-icon>
        <v-icon v-if="['maneuver','spells','feats','perks'].includes(item.uiType) && (item.hidden && item.hidden==true)" @click="toggleHide()" size="1.1em" dense color="grey">visibility</v-icon>
        
        <v-icon v-if="character && item.uiType=='wonderousItems'" @click="destroy" color="grey">delete</v-icon>

      </v-card-title>
      <v-divider/>
      <v-card-text v-if="item.uiType" :style="`color:white`">
      <div style="text-align:left">
        <div v-if="item.rarity && item.rarity !='none'">
          <div style="display:flex; justify-content:space-between">
            Rarity: {{ item.rarity }} <span v-if="item.uiType == 'weapon' && character"><v-icon @click="weaponAlt +=1; if(weaponAlt > 2){weaponAlt = 0}" style="color:antiquewhite">sync</v-icon> </span><br />
          </div> 
        </div>
        <p v-if="item.enchantments && isLarger(item.enchantments.length, 0)">
          Item is enchanted!
        </p>
        <p v-if="item.uiType == 'class'">
          <b>Base Stats:</b> {{item.baseStats}}
          <br /><b>Ability Scores:</b> {{item.abilityScores}} 
          <br /><br /><b>Rolls:</b><br /> <span style="white-space: break-spaces;">{{ item.Rolls }}</span>
        </p>
        <p v-if="item.uiType == 'stats'">
          <br />
          Stat: {{ item.stat }} <br />
          Bonus: {{ item.bonus }}           
        </p>
        <div v-if="item.drawback">
          <p>
          <br /> Drawback: {{ item.drawback }}
          <br /> Penalty: {{ item.penalty }}
          </p>
        </div>
        <div v-if="item.uiType == 'perks'" style="white-space: pre-wrap">
          <div v-if="item.type || !item.type && item.rarity != 'class'">
            <div v-if="item.fromClass">From: {{item.fromClass}}<br />
            </div>
            <div v-if="item.sphere">Sphere: {{item.sphere}}<br />
            </div>
            <div v-if="item.talentType">Talent Type: {{item.talentType}}<br />
            </div>
            <div v-if="item.abilityType">Ability Type: {{item.abilityType}}<br /></div>
            <span v-if="item.type">Type: {{ item.type }}</span>            
            <v-row style="align-items: center;margin-bottom: 8px;margin-top: 4px;"><v-divider></v-divider> Description <v-divider></v-divider></v-row>
            <v-row v-if="item.hasButtonMethod && character" no-gutters style="margin-bottom: 8px;margin-top: -8px;">
              <v-col v-for="buttonMethod in item.buttonMethods" v-bind:key="buttonMethod.title" style="text-align: center;">
                <v-btn small @click="emitButtonMethod(buttonMethod)" >{{buttonMethod.title}}</v-btn>
              </v-col>
            </v-row>
            <p v-if="item.shortDesc">{{item.shortDesc}}
            </p>            
            <p v-else
              >Activating a gambit is a swift action, the requirement lists the action you need to take on your turn, if you succeed it you gain the bonus, otherwise you receive a -2 to all d20 rolls for 1 round. You may add half your highest mental stat as a luck bonus to any d20 roll you make while performing the requirement action.
              <br/><br/><b>Requirement:</b> {{item.requirement}} 
              <br/><b>Bonus:</b> Recover maneuvers equal to your highest mental modifier (minimum 2) and {{item.bonus}} <br/>
            </p>  
          </div>
          <div v-else>
            <v-row style="align-items: center;margin-bottom: 8px;margin-top: 4px;"><v-divider></v-divider> Description <v-divider></v-divider></v-row>
            {{item.longDesc}}<br/>
          </div>  
        </div>
        <div v-if="item.uiType == 'race'" style="white-space: pre-wrap">
          <v-row style="align-items: center;margin-bottom: 8px;margin-top: 4px;"><v-divider></v-divider> Description <v-divider></v-divider></v-row>
          {{item.longDesc}}<br/>
        </div>
        <div v-if="item.uiType == 'feats'" style="white-space: pre-wrap"
        >Type: {{ item.type }} <br />

          <div v-if="item.prereq"
          >Prereq: {{item.prereq}} <br />
          </div>
          <div v-if="item.cost"
          >Level Modification: {{item.cost}} 
          <br />Spell Point Cost: {{parseInt(item.cost)*2}} <br />
          </div>
          <div v-if="item.from"
          >Teamwork Feat From: {{item.from}}
          </div>
          <div v-if="item.to"
          >Feat Sent To: {{item.to}}
          </div>
          <div v-if="item.perkPrereq"
          >Perk Prereq: <span v-for="ability in item.perkPrereq" :key="ability">{{ability + ", "}}</span><br /><br />
          </div>
          <v-row style="align-items: center;margin-bottom: 8px;margin-top: 4px;"><v-divider></v-divider> Description <v-divider></v-divider></v-row>
          <div v-if="(item.longDesc && item.longDesc.length == 0) || !item.longDesc "
          >{{ item.shortDesc }} <br />
          </div>
          <div v-if="item.longDesc && item.longDesc.length != 0"
          >{{ item.longDesc }} <br />
          </div>
 
        </div>
        <div v-if="item.uiType == 'armor'">
          <br />
          <v-row>
            <v-col>
              Armor Bonus: {{ item.armorBonus }} <br />
              Armor Check Penalty: {{ item.armorCheck }} <br />
              Max Dex: {{ item.maxDex }} <br />
              Type: {{ item.type }} <br />
            </v-col>
            <v-col>
              Hardness: {{ hardness }} <br />
              Hitpoints: {{ hitpoints }} <br />
              <span v-if="enhancementModifier.bonus > 0">Enhancement Modifier: {{enhancementModifier.bonus}}<br /></span>
              <!-- <span v-if="enhancementModifier.highest > 0">Highest Enchantment: {{enhancementModifier.highest}}<br /></span> -->
              <span v-if="casterLevel > 0">Caster Level: {{casterLevel}}<br /></span>
              

            </v-col>
          </v-row>
          
          
          <div v-if="item.special">
            Special: {{item.special}}<br />
          </div> <br /> 
          <div v-if="character && item.type != 'shield'">
            Armor Class: {{armorClass.baseArmor}} <br />
            Flat-Footed: {{armorClass.flatFooted}} <br />
            Touch: {{armorClass.touch}} <br />
          </div>
          <div v-else-if="character">
              Shield Bonus: {{armorClass.shieldAC}}
          </div>
          <!-- <div v-else-if="character">
            Shield Bonus: {{}}
          </div> -->
          <v-card v-for="item in item.enchantments" v-bind:key="item.id" :style="`color:white; border-width:thick; border-style:ridge; border-color:${borderColor(item)}`" :img="require(`../assets/${backColor(item.rarity)}`)">
            <v-card-text :style="`color:white; padding-top:1px`">
            <p></p>
            Name: {{ item.name }}
            <br /><br />
            Rarity: {{ item.rarity }} <br />
            Bonus: {{ item.bonus }}
            </v-card-text>
          </v-card>
        </div>
        <div v-if="item.uiType == 'spells'">
          <v-row>
            <v-col sm="6">
              Level {{ item.level }}
              <br />Type: <span v-for="type in item.type" v-bind:key="type"> {{type}}, </span>
              <br />Range: {{ item.range }} <br />
              <span v-if="isLarger(item.area.length,0)">Area: {{ item.area }} <br /></span>
              <div v-if="item.targets && isLarger(item.targets.length,1)">Targets: {{ item.targets }} <br /></div>
              Duration: {{ item.duration }} <br />
              Saving Throw: {{ item.savingThrow }} <br />              
            </v-col>
            <v-col>
              <br />Casting Time: {{ item.castingTime }} <br />
              <div v-if="item.spCost">Sp Cost: {{ item.spCost }}<br/></div>
              School: {{ item.school }}<span v-if="item.tags && item.tags.length > 0"> <span v-for="tag in item.tags" v-bind:key="tag"> [{{tag}}], </span></span><br />
              <span v-if="isLarger(item.effect.length, 0)">Effect: {{ item.effect }} <br /></span>
              <span v-if="item.components && isLarger(item.components.length, 0)">Components: {{ item.components }} <br /></span>
              <span v-if="item.spellResistance && isLarger(item.spellResistance.length, 0)">Spell Resistance: {{ item.spellResistance }} <br /></span>
              <span v-if="item.temporary">Temporary: {{ item.temporary }} <br /></span>
            </v-col>
          </v-row>
          <v-row style="align-items: center;margin-bottom: 8px;margin-top: 8px;"><v-divider></v-divider> Description <v-divider></v-divider></v-row>
         <span style="white-space: pre-wrap"
         >{{ item.longDesc }} <br />
         </span>
        </div>
        <div  v-if="item.uiType && item.uiType.includes('man')" style="white-space: pre-wrap">
          <v-row>
            <v-col
              >Level {{ item.level }} 
              <span v-if="item.school"><br />School: {{ capitalize(item.school) }} </span>
              <span v-else><br/>Tags: <span v-for="(tag,index) in item.comboTags" v-bind:key="tag">{{tag}}<span v-if="item.comboTags[index+1]">, </span></span></span>
              <br />Type: {{ item.type }} <br />
              <div v-if="item.duration">Duration: {{ item.duration }} <br /></div>
            </v-col>
            <v-col
            ><span v-if="!characterSheetOverride">Sp Cost: {{ getSpCost(item) }} <br /></span>
              <div v-if="item.initiationAction">Initiation Action: {{ item.initiationAction }} <br /></div>
              <div v-if="item.range">Range: {{ item.range }} <br /></div>
              <div v-if="item.target">Target: {{ item.target }} <br /></div>
              <div v-if="item.savingThrow">Save: {{ item.savingThrow }} <br /></div>
            </v-col>
            <span v-if="item.oldDesc" style="position:absolute; right:10px; display:grid;">
              <span style="font-size:8px">Old Desc</span><input type="checkbox" v-model="showOldDesc"/>
            </span>
          </v-row>
          <v-row style="align-items: center;margin-bottom: 8px;margin-top: 8px;"><v-divider></v-divider> Description <v-divider></v-divider></v-row>
          <div v-if="item.longDesc.length ==0"
          >{{ item.shortDesc }} <br />
          </div>
          <div v-if="item.longDesc.length != 0"
          >{{ showOldDesc ? item.oldDesc : item.longDesc}} <br />
          </div>
        </div>
        <v-card-title v-if="item.uiType == 'player'">
          Send {{item.feat.name}} to: {{item.playerName}}
        </v-card-title>
        <div v-if="item.uiType == 'weapon'">
          <br />
          <div v-if="weaponAlt == 0">
            <v-row style="text-align:left">
              <v-col>
                Class: {{ item.class }} <br />
                <span v-if="item.group">
                  Group: {{ item.group }} <br />
                </span>
                Damage: {{ item.damage }}
              </v-col>
              <v-col>
                <span v-if="!item.handsNeeded">
                  Type: {{ item.type }} <br />
                </span>
                <span v-else>
                  Hands: {{item.handsNeeded}} <br />
                </span>
                <span v-if="item.damageType">Damage Type: {{ item.damageType }} <br /></span>
                <div>Crit: {{ item.crit }} </div>
              </v-col><br/>
            </v-row>
            <div v-if="isLarger(item.range.length, 1)" style="text-align:left" >
            Range: {{ item.range }} <br/>
            </div>
            <div v-if="item.spCost">
              Sp Cost: {{ item.spCost }} <br/>
            </div>
            <div v-if="isLarger(item.special.length,1)" style="white-space: pre-wrap">
              <br/>Special: {{ item.special }}
            </div><br/>
            <div v-if="item.spellPower && !character">
              Spell Power: <span v-for="type in item.spellPower" v-bind:key="type.type">{{type.type}}: {{ type.power }}, </span>
            </div>
            <div v-if="item.spellCriticalChance && !character">
              Spell Critical Chance: <span v-for="type in item.spellCriticalChance" v-bind:key="type.type">{{type.type}}: {{ type.power }}, </span>
            </div>
            <div v-if="item.spellCriticalDamage && !character">
              Spell Critical Damage: <span v-for="type in item.spellCriticalDamage" v-bind:key="type.type">{{type.type}}: {{ type.power }}, </span>
            </div>
          </div>
        <div v-else-if="weaponAlt == 1">
          <v-row>
            <v-col>
          Hardness: {{ hardness }} <br />
          Hitpoints: {{ hitpoints }} <br />
          <span v-if="isLarger(item.enchantments.length, 0)">
          Caster Level: {{ casterLevel }}<br/>
          </span><br/>
            </v-col>
            <v-col>
              <span v-if="enhancementModifier.bonus > 0">Enhancement Modifier: {{enhancementModifier.bonus}}<br /></span>
              <span v-if="enhancementModifier.highest > 0">Highest Enchantment: {{enhancementModifier.highest}}<br /></span>
            </v-col>
          </v-row>
        </div>
        <div v-else-if="weaponAlt == 2">
          <v-row>
            <v-col>
              Spell Power:<br/>
              <span>
                <span v-for="type in ['universal','fire','cold','electricity','acid','positive','negative']" v-bind:key="type">
                <span>{{type}}: {{ totalSpellPower(type) }} <br/></span>
                </span>
              </span><br/>
            </v-col>
            <v-col>
              Spell Critical:<br/>
              <span >
                <span v-for="type in ['universal','fire','cold','electricity','acid','positive','negative']" v-bind:key="type">
                <span>{{type}}: {{ totalSpellCriticalChance(type) }}% (+{{totalSpellCriticalDamage(type)}}%)<br/></span>
                </span>
              </span><br/>
            </v-col>
          </v-row>

            <div v-if="item.spCost">
              Sp Cost: {{ item.spCost }} <br/><br/>
            </div>
            <div v-if="item.spellPower">
              Spell Power: <span v-for="type in item.spellPower" v-bind:key="type.type">{{type.type}}: {{ type.power }}, </span>
            </div>
            <div v-if="item.spellCriticalChance">
              Spell Critical Chance: <span v-for="type in item.spellCriticalChance" v-bind:key="type.type">{{type.type}}: {{ type.power }}, </span>
            </div>
            <div v-if="item.spellCriticalDamage">
              Spell Critical Damage: <span v-for="type in item.spellCriticalDamage" v-bind:key="type.type">{{type.type}}: {{ type.power }}, </span> <br/><br/>
            </div>
          </div>
          <!-- <div v-if="isLarger(item.special.length, 1)">
          Special: {{ item.special }} <br /> <br />
          </div> -->
          <div v-if="character">
            Attack: {{attackModifier}} <br /> <br />
            <div v-if="item.class != 'ranged'">
              One Handed Damage: {{oneHandedDamage}}
              <br/>Two Handed Damage: {{twoHandedDamage}}
              <br/>Off Hand Damage: {{offHandDamage}}
            </div>            
            <div v-if="item.class=='ranged'">
              Ranged Damage: {{rangedDamage}}
            </div>
          </div>
          
          <p></p>
          <v-card v-for="item in item.enchantments" v-bind:key="item.id" class="my-1" :style="`color:white; border-width:thick; border-style:ridge; border-color:${borderColor(item)}`" :img="require(`../assets/${backColor(item.rarity)}`)">
            <v-card-text :style="`color:white; padding-top:1px; white-space: pre-wrap`">
            <p></p
            ><span style="display:flex; justify-content:space-between; align-items:center"
            >Name: {{ item.name }}             
            <span v-if="item.additionalInfo || item.additionalInfoTags">
            <v-tooltip  bottom max-width="500">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" :style="`color:${textColor(item.rarity)};padding-bottom:2px;margin-right:4px`">help_outline</v-icon>
              </template>
              <span style="white-space: pre-wrap; max-width:400px">{{setEnchantmentAdditionalInfo(item)}}</span>
            </v-tooltip>
            </span>
            </span
            >Rarity: {{ item.rarity }}
            <br/>Class: {{ item.class }}
            <br/>Description: {{ item.shortDesc }}
            </v-card-text>
          </v-card>
        </div>
        <div v-if="item.uiType == 'weaponEnchantment'" style="white-space: pre-wrap"
        >Description: {{item.shortDesc}}
        </div>
        <div v-if="item.uiType == 'armorEnchantments'">
          Name: {{item.name}} <br />
          Bonus: {{item.bonus}} <br />
        </div>
        <div v-if="item.uiType == 'gear'">
          Stack: {{item.stack}}<br/>
          Description: {{item.longDesc}}
        </div>
        <div v-if="item.uiType == 'wonderousItems'">
          type: {{item.type[0]}}<span v-if="item.type[1]">, {{item.type[1]}}</span>
          <br/><br/><div v-if="item.stat">Score Bonuses:
            <span v-if="statNames.includes(item.stat[0])">
              <span v-for="stat in item.stat" v-bind:key="stat">
                {{stat}},
              </span>
            </span>
            <span v-else>
              {{item.stat}}
            </span>
          </div 
          ><span style="white-space: pre-wrap!important"
          >Description: {{item.longDesc}}</span>
        </div>
      </div>      
      <div v-if="character && ((item.uiType=='maneuver' && item.school=='radiantDawn') || (item.uiType=='feats' && item.givesEssence))" style="display: inline-flex; align-items: center;">
        Essence Invested: 
        <div style="display:flex; flex-direction:column; align-items:center">
          <v-icon @click="increaseEssence()" style="margin-bottom:-11px;height:28px;width:28px;font-size:30px;">mdi-chevron-up</v-icon> 
          <div>{{item.investedEssence}}</div>
          <v-icon @click="reduceEssence()" style="margin-top:-12px;height:28px;width:28px;font-size:30px;padding-left:1px;">mdi-chevron-down</v-icon>
        </div>
      </div>
      <div v-if="(characterSheetOverride || character) && item.uiType=='maneuver' && item.stacksOneName" style="display: inline-flex; align-items: center;">
        {{item.stacksOneName}}:
        <div style="display:flex; flex-direction:column; align-items:center">
          <v-icon @click="item.stacksOne += 1" style="margin-bottom:-11px;height:28px;width:28px;font-size:30px;">mdi-chevron-up</v-icon> 
          <div>{{item.stacksOne}}</div>
          <v-icon @click="item.stacksOne == 0 ? item.stacksOne = 0 : item.stacksOne -= 1;" style="margin-top:-12px;height:28px;width:28px;font-size:30px;padding-left:1px;">mdi-chevron-down</v-icon>
        </div>
      </div>
      </v-card-text>

      <v-dialog v-model="weaponModifiers" v-if="item.uiType=='weapon' && character" width="600">
      <v-card style="overflow: hidden; background-color:antiquewhite;">
        <v-card-title class="headline brown darken-4 white--text">Weapon Modifier Options</v-card-title>
        <v-card-text style="color:black" class="ma-1 pt-2">
          You can modify what stats affect a specific weapon's attack and damage
          <br /><br />
          <v-row no-gutters>
            <v-col>
          <v-combobox
            style="margin-right:16px"
            v-model="statsForAbilities.atkStat"
            :items="statNames"
            label="Attack Stat"            
            outlined
            dense
          ></v-combobox>
          </v-col>
          <v-col style="align-items:baseline;display:flex">
          Attack Modifier:
          <v-text-field v-model="statsForAbilities.bonusAtk" dense single-line style="width: 50px;margin-right:4px;margin-left:4px" :rules="[rules.number]"></v-text-field>
          </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col>
              <v-combobox
                style="margin-right:16px"
                v-model="statsForAbilities.dmgStat"
                :items="statNames"
                label="Damage Stat"
                outlined
                dense
              ></v-combobox>
            </v-col>
            <v-col style="align-items:baseline;display:flex">
              Damage Modifier:
              <v-text-field v-model="statsForAbilities.bonusDmg" dense single-line style="width: 50px;margin-right:4px;margin-left:4px" :rules="[rules.number]"></v-text-field>
            </v-col>
          </v-row>
          <v-row style="justify-content:center; align-items:baseline">
          Dice Steps:
          <div style="display:inline-flex; align-items:end">
            <v-text-field v-model="statsForAbilities.dieSteps" dense single-line hide-details type="number" style="width: 50px; margin-right:4px;margin-left:4px"></v-text-field>
            <v-tooltip right style="margin-right:4px">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on">help_outline</v-icon>
              </template>
              <span>Increases to size normally count as 2 dice step increases <br/>If you're increasing size and your weapon deals 1d6 or less your damage step only goes up by 1<br/>If you're decreasing size and your weapon deals 1d8 or less your damage step only goes down by 1</span>
            </v-tooltip>
          </div>
          </v-row>
          <v-row style="margin-top:24px; justify-content:center" v-if="item.type=='custom'">
            <v-btn class="ma-2 brown darken-4 white--text"  @click="editWeaponDialog = true">Edit Weapon</v-btn>
            <v-btn class="ma-2 brown darken-4 white--text"  @click="destroy()">Delete Weapon</v-btn>
          </v-row>
      </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editWeaponDialog" width="600">
      <v-card style="overflow: hidden; background-color:antiquewhite;max-width:600px">
        <v-card-title class="headline brown darken-4 white--text" >Edit Custom Weapon</v-card-title>
        <v-card-text style="color:black; font-weight:500" class="ma-1 mt-4 pt-2">
          <v-row style="justify-content:center">
            <v-text-field label="Name" v-model="item.name" class="ml-1" dense style="max-width: 300px"></v-text-field>
          </v-row>
          <v-row style="justify-content:left">
            <v-text-field label="Damage" v-model="item.damage" class="ml-1" dense style="max-width: 200px"></v-text-field>
            <v-text-field label="Critical" v-model="item.crit" class="ml-1" dense style="max-width: 200px"></v-text-field>
            <v-text-field label="Damage Type" v-model="item.damageType" class="ml-1" dense style="max-width: 200px"></v-text-field>
          </v-row>
          <v-row>
            <v-textarea label="Notes:" v-model="item.special" class="ml-1" dense style="width: 400px;" no-resize></v-textarea>
          </v-row>
      </v-card-text>
      </v-card>
    </v-dialog>

    </v-img>
  </v-card>
  
</template>
<script>
import {diceSteps,weapons, customWeaponMethods} from "./data"
import {additionalInfoTags, skillToSpellBonus} from "./constants"
//import MultiUseCard from './MultiUseCard'
export default {
  mounted() {
      this.createDefault()
  },
  props: {
    item: {},
    character:{},
    modifierStats:{},
    characterSheetOverride: Boolean,
  },
  data(){
    return{
      skillToSpellBonus:skillToSpellBonus,
      showOldDesc:false,
      componentKey:0,
      editWeaponDialog: false,
      weaponAlt:0,
      diceSteps,
      weaponModifiers: false,
     // simpleExplanation: false,
      statNames:["strength","dexterity","constitution","intelligence","wisdom","charisma","none"],
      statsForAbilities:{
        atkStat:"strength",
        bonusAtk:0,
        dmgStat:"none",
        bonusDmg:0,
        dieSteps:0,
      },
      rules: {              
          number: value => {            
            return (parseInt(value) || value=="0") || 'Must Be a Number'
          }
      },
    }
  },
  computed:{
    spellAugment(){
      let types = ["universal", "fire", "cold", "electricity", "acid", "positive", "negative"]
      let spellAugment = {spellPower:[], spellCriticalChance:[], spellCriticalDamage:[]}
      types.forEach(type => {
        spellAugment.spellPower[type] = 0
        spellAugment.spellCriticalChance[type] = 0
        spellAugment.spellCriticalDamage[type] = 0
      })
      if(this.item.spellPower){
        this.item.spellPower.forEach(power => { 
          spellAugment.spellPower[power.type] += parseInt(power.power)
        })
      }
      if(this.item.spellCriticalChance){
        this.item.spellCriticalChance.forEach(critical => {
          spellAugment.spellCriticalChance[critical.type] += parseInt(critical.power)
        })
      }
      if(this.item.spellCriticalDamage){
        this.item.spellCriticalDamage.forEach(damage => {
          spellAugment.spellCriticalDamage[damage.type] += parseInt(damage.power)
        })
      }
      this.item.enchantments.forEach(enchantment => {
        if(enchantment.spellCriticalChance){
          enchantment.spellCriticalChance.forEach(critical => {
            spellAugment.spellCriticalChance[critical.type] += parseInt(critical.power)
          })
        }
        if(enchantment.spellCriticalDamage){
          enchantment.spellCriticalDamage.forEach(damage => {
            spellAugment.spellCriticalDamage[damage.type] += parseInt(damage.power)
          })
        }
        if(enchantment.spellPower){
          enchantment.spellPower.forEach(power => {
            spellAugment.spellPower[power.type] += parseInt(power.power)
          })
        }
      })
      return spellAugment
    },
    bab(){
      if(this.modifierStats.lvlForBab){
        return parseInt(this.character.misc.level)
      }else{
        return parseInt(this.character.misc.BAB)
      }
    },
    attackModifier(){
      let modifier = 0
      let abilityMod = this.statsForAbilities.atkStat != "none" ? Math.floor((this.character.modifiedStats[this.statsForAbilities.atkStat]-10)/2) : 0      
      modifier = abilityMod + parseInt(this.statsForAbilities.bonusAtk) + parseInt(this.modifierStats.bonusAtk) + this.bab - Math.abs(parseInt(this.character.tempModifiers.negativeLevels))
      this.item.enchantments.forEach(enchantment => {
        if(enchantment.name.substring(0,1) == "+"){          
          modifier += parseInt(enchantment.name.substring(1,2))
        }
        if(enchantment.name =="Titanic"){
          modifier -= 4
        }
      })
      if(this.modifierStats.combatExpertise ){
        modifier -= Math.floor((this.bab/4))+1
      }
      if(this.modifierStats.powerAttack && this.item.name != "Buster Sword"){
        modifier -= Math.floor((this.bab/4))+1
      }
      let modifierString = "" 
      for(let x = 0; x < Math.ceil((this.bab/5)); x++){
        if(x != 0) modifierString +="/"
        let num = modifier - 5*x
        modifierString += "+" + num        
      }
      if(modifierString == ""){
        modifierString = "+" + modifier
      }
      return modifierString
    },
    offHandDamage(){
      let abilityMod = this.statsForAbilities.dmgStat != "none" ? Math.floor(Math.floor((this.character.modifiedStats[this.statsForAbilities.dmgStat]-10)/2)) : 0
      if(abilityMod > 0){
        abilityMod = Math.floor(abilityMod  * 0.5)
      }
      let modifier = abilityMod + parseInt(this.statsForAbilities.bonusDmg) + parseInt(this.modifierStats.bonusDmg)
      if(this.modifierStats.powerAttack){
        modifier += (Math.floor((this.bab/4))+1)
      }
      return this.getDamageString(modifier,"off")
    },
    oneHandedDamage(){
      let abilityMod = this.statsForAbilities.dmgStat != "none" ? Math.floor((this.character.modifiedStats[this.statsForAbilities.dmgStat]-10)/2) : 0
      let modifier = abilityMod + parseInt(this.statsForAbilities.bonusDmg) + parseInt(this.modifierStats.bonusDmg)
      if(this.modifierStats.powerAttack){
        modifier += 2 * (Math.floor((this.bab/4)) + 1)
      }
      return this.getDamageString(modifier,"one")
    },
    twoHandedDamage(){
      let abilityMod = this.statsForAbilities.dmgStat != "none" ? Math.floor(Math.floor((this.character.modifiedStats[this.statsForAbilities.dmgStat]-10)/2)) : 0
      if(abilityMod > 0){
        if(this.item.name != "Giant Hunk Of Iron") abilityMod = Math.floor(abilityMod * 1.5)
        else abilityMod = Math.floor(abilityMod * 2)
      }
      let modifier = abilityMod + parseInt(this.statsForAbilities.bonusDmg) + parseInt(this.modifierStats.bonusDmg)
      if(this.modifierStats.powerAttack){
        modifier += 3 * (Math.floor((this.bab/4))+1)
      }
      return this.getDamageString(modifier,"two")
    },
    rangedDamage(){
      let weaponDB = weapons.find(weapon=> weapon.name == this.item.name)

      let modifier = 0
      let abilityMod = this.statsForAbilities.dmgStat != "none" ? Math.floor((this.character.modifiedStats[this.statsForAbilities.dmgStat]-10)/2) : 0 
     
      if(weaponDB && weaponDB.customModifier){
        modifier = parseInt(weaponDB.customModifier(this, modifier))
      }
      if(weaponDB && weaponDB.overrideModifier){
        abilityMod = weaponDB.overrideModifier(this, modifier)
      }
      
      if(weaponDB && weaponDB.customWeaponMethods){
        for(let x = 0; x < weaponDB.customWeaponMethods.length; x++){
          let customMethod = weaponDB.customWeaponMethods[x]
          if(customMethod.name == "cappedMod"){
            abilityMod = parseInt(customWeaponMethods.cappedMod(this, this.statsForAbilities.dmgStat, customMethod.cap))
          }
          if(customMethod.name == "additionalMod"){
            modifier = parseInt(customWeaponMethods.additionalMod(this, modifier, customMethod.cap, customMethod.stat))
          }
        }
      }
      
      if(this.modifierStats.powerAttack){
        modifier += 2 * (Math.floor((this.bab/4))+1)
      }
      modifier += abilityMod + parseInt(this.statsForAbilities.bonusDmg) + parseInt(this.modifierStats.bonusDmg)
      return this.getDamageString(modifier,"ranged")
    },
    armorClass(){
      let naturalArmor = 0
      let deflection = 0
      let shield = 0
      let dodge = 0
      if(this.modifierStats.combatExpertise ){
        dodge += 1 + Math.floor((this.bab/4))
      }
      let armor = parseInt(this.item.armorBonus)
      let enchantmentBonus = 0
      let statModifier = Math.floor((this.character.modifiedStats[this.modifierStats.ac.abilityMod]-10)/2)
      if(this.item.maxDex != "-" && statModifier > parseInt(this.item.maxDex) + parseInt(this.modifierStats.ac.armorCheckMod)){
        statModifier = parseInt(this.item.maxDex) + parseInt(this.modifierStats.ac.armorCheckMod)
      }
      //let multiplier = 1
      this.item.enchantments.forEach(enchantment => {
        if(enchantment.name.substring(0,1) == "+"){        
          enchantmentBonus += parseInt(enchantment.name.substring(1,2))                  
        }
        if(enchantment.name == "Deflecting"){
          deflection += 2 
        }
        if(enchantment.name == "Shielding"){
          shield += 4
        }
        if(enchantment.name == "Scabbing"){
          naturalArmor += 2
        }
        // if(enchantment.name == "Enhancement Enhancement"){
        //   multiplier += 1
        // }
        if(enchantment.name == "Swift Armor" || enchantment.name == "Dodging"){
          dodge += 1
        }
      })
      // enchantmentBonus *= multiplier
      // deflection *= multiplier
      // shield *= multiplier
      // naturalArmor *= multiplier
      let flatStatModifier = statModifier < 0 ? statModifier : 0 
      let baseArmor = 10 + armor + statModifier + Math.max(deflection, this.modifierStats.ac.deflection) + Math.max(shield, this.modifierStats.ac.shield) + naturalArmor + parseInt(this.modifierStats.ac.natural) + enchantmentBonus + parseInt(this.modifierStats.ac.dodge) + parseInt(this.modifierStats.ac.untyped) + parseInt(this.modifierStats.ac.armor) + dodge + parseInt(this.modifierStats.ac.insight) + parseInt(this.modifierStats.ac.sacred) + parseInt(this.modifierStats.ac.size) + parseInt(this.modifierStats.ac.luck) 
      let touch = 10 + statModifier + Math.max(deflection, this.modifierStats.ac.deflection) + parseInt(this.modifierStats.ac.dodge) + parseInt(this.modifierStats.ac.untyped) + dodge + parseInt(this.modifierStats.ac.luck) + parseInt(this.modifierStats.ac.sacred) + parseInt(this.modifierStats.ac.insight) + parseInt(this.modifierStats.ac.size)
      let flatFooted = 10 + armor + flatStatModifier + Math.max(deflection, this.modifierStats.ac.deflection) + Math.max(shield, this.modifierStats.ac.shield) + naturalArmor + parseInt(this.modifierStats.ac.natural) + enchantmentBonus + parseInt(this.modifierStats.ac.untyped) + parseInt(this.modifierStats.ac.armor) + parseInt(this.modifierStats.ac.insight) + parseInt(this.modifierStats.ac.sacred) + parseInt(this.modifierStats.ac.size) + parseInt(this.modifierStats.ac.luck) 
      let shieldAC = Math.max(armor + enchantmentBonus, shield)
      let ac = {baseArmor, touch, flatFooted, shieldAC}
      return ac
    },
    hardness(){
      return parseInt(this.item.hardness) + 2 * parseInt(this.getEnhancements().bonus)
    },
    hitpoints(){
      if(this.item.hitPoints) return parseInt(this.item.hitPoints) + (10 * parseInt(this.getEnhancements().bonus))
      else{
        return parseInt(this.item.armorBonus) * 5 + (10 * parseInt(this.getEnhancements().bonus))
      }
    },
    enhancementModifier(){
      let enchantments = {bonus:0, highest:0}
      this.item.enchantments.forEach(enchantment => {
        if(enchantment.name.substring(0,1) == "+"){
          let enchantmentBonus = parseInt(enchantment.name.substring(1,2))
          enchantments.bonus += enchantmentBonus
          if(enchantmentBonus > enchantments.highest) enchantments.highest = enchantmentBonus
        }
      })
      return enchantments
    },

    casterLevel(){
      // let highestEnhancement = this.getEnhancements()
      // if(highestEnhancement.list.length > 0){
      //   highestEnhancement = highestEnhancement.list.sort(function(a, b){return b-a})[0].name.substring(1,2) * 3
      //   //return (parseInt(highestEnhancment) * 3) + (this.item.enchantments.length-1)
      // }
      let misc = 0
      this.item.enchantments.forEach(enchantment =>{
        if(enchantment.name == "Beholder's Bane"){
          misc += 4
        }
      })
      let rarities = this.item.enchantments.map(enchantment=> enchantment.rarity)
      let highest = 0
      if(rarities.includes("unique")) highest = 15
      else if(rarities.includes("legendary")) highest = 12
      else if(rarities.includes("epic")) highest = 9
      else if(rarities.includes("rare")) highest = 6
      else if(rarities.includes("common")) highest = 3
      return highest + this.item.enchantments.length-1 + misc
      //highest = hightest > highestEnhancement ? highest: highestEnhancement
    },
  },
  methods:{
    getSkillBonusToPower(statType, spellType){
      if(spellType == "universal") return 0
      let bonus = this.skillToSpellBonus[statType][spellType]
      return Math.floor(this.character.skills[bonus.skill] * bonus.rate)
    },
    universalSpellPower(){
      let universalPower = this.character.spellMastery.spellPower.universal + parseInt(this.character.spellMastery.modifier.spellPower.universal)
      if(this.spellAugment.spellPower.universal){
        universalPower += this.spellAugment.spellPower.universal
      }
      return universalPower
    },
    universalSpellCriticalChance(){
      let universalCriticalChance = this.character.spellMastery.spellCriticalChance.universal + parseInt(this.character.spellMastery.modifier.spellCriticalChance.universal)
      if(this.spellAugment.spellCriticalChance.universal){
        universalCriticalChance += this.spellAugment.spellCriticalChance.universal
      }
      return universalCriticalChance
    },
    universalSpellCriticalDamage(){
      let universalCriticalDamage = this.character.spellMastery.spellCriticalDamage.universal + parseInt(this.character.spellMastery.modifier.spellCriticalDamage.universal)
      if(this.spellAugment.spellCriticalDamage.universal){
        universalCriticalDamage += this.spellAugment.spellCriticalDamage.universal
      }
      return universalCriticalDamage
    },
    totalSpellPower(type){
      if(type == "universal") return this.universalSpellPower()
      return this.universalSpellPower() + this.getSkillBonusToPower("spellPower", type) + this.character.spellMastery.spellPower[type] + parseInt(this.character.spellMastery.modifier.spellPower[type]) + this.spellAugment.spellPower[type]
    },
    totalSpellCriticalChance(type){
      if(type == "universal") return this.universalSpellCriticalChance()
      return this.universalSpellCriticalChance() + this.getSkillBonusToPower("spellCriticalChance", type) + this.character.spellMastery.spellCriticalChance[type] + parseInt(this.character.spellMastery.modifier.spellCriticalChance[type]) + this.spellAugment.spellCriticalChance[type]
    },
    totalSpellCriticalDamage(type){
      if(type == "universal") return this.universalSpellCriticalDamage()
      return this.universalSpellCriticalDamage() + this.getSkillBonusToPower("spellCriticalDamage", type) + this.character.spellMastery.spellCriticalDamage[type] + parseInt(this.character.spellMastery.modifier.spellCriticalDamage[type]) + this.spellAugment.spellCriticalDamage[type]
    },
    destroy(){
      this.$emit('destroy', this.item)
    },
    increaseEssence(){
      this.$emit('increaseEssence', this.item)
      //this.componentKey = Math.random()
    },
    reduceEssence(){
      this.$emit('reduceEssence', this.item)
      //this.componentKey = Math.random()
    },
    isLarger(num1,num2){
      if(num1 > num2) return true
      else return false
    },
    getEnhancements(){
      let enchantments = {list:[], bonus:0}
      this.item.enchantments.forEach(enchantment => {
        if(enchantment.name.substring(0,1) == "+"){          
          enchantments.bonus += parseInt(enchantment.name.substring(1,2))
          enchantments.list.push(enchantment)
        }       
      })
      return enchantments
    },
    setAdditionalInfo(){
      let str = ``
      if(this.item.additionalInfo) str = str + this.item.name + `:\n` + this.item.additionalInfo + `\n\n`
      if(this.item.additionalInfoTags){
        this.item.additionalInfoTags.forEach(tag=>{
          str += tag + `:\n`
          str += additionalInfoTags[tag] + `\n\n`
        })  
      }
      return str
    },
    setEnchantmentAdditionalInfo(item){
      let str = ``
      if(item.additionalInfo) str = str + item.name + `:\n` + item.additionalInfo + `\n\n`
      if(item.additionalInfoTags){
        item.additionalInfoTags.forEach(tag=>{
          str += tag + `:\n`
          str += additionalInfoTags[tag] + `\n\n`
        })  
      }
      return str
    },
    capitalize(str){ 
        for(let x = 0; x < str.length; x++){
            if(str[x].toUpperCase() == str[x]){
                str = str.substring(0,x) + " " + str.substring(x,str.length)
                x++
            }
        }            
        let newStr = str[0].toUpperCase() + str.substring(1)
        return newStr
      },
      getSpCost(item){
        if(item.spCost) return item.spCost 
        let strikeAr = [0,0,1,1,2,3,5,7,9]
        let bslashcAr = [0,1,1,2,3,5,7,9,12]
        let utilsp = [0,0,1,1,2,3,5,7,9]
        if(item.type == "Stance") return 0
        else if(item.additionalInfoTags && item.additionalInfoTags.includes("Sterling Tactic")){return item.type == "Strike" ? Math.ceil(strikeAr[item.level-1]/2)+item.stacksOne : Math.ceil(bslashcAr[item.level-1]/2)+item.stacksOne}
        else if(item.utility == true) return utilsp[item.level-1]
        else if(item.type == "Finisher") return "level/2"
        else if(item.type == "Strike") return strikeAr[item.level-1]
        else if(item.type == "Boost" && item.additionalInfoTags && item.additionalInfoTags.includes("Shadow Technique")) return 0
        else if (item.type == "Boost" || item.type == "Counter") return bslashcAr[item.level-1]
      },
    // replaceDesc(text){
    //   if(this.item.alternateDescs){
    //     let textArr = text.split("!-")
        
    //     let rebuilt = ""
    //     for(let x = 0; x < textArr.length; x++){
    //       let extraText = textArr[x].split("-!")
    //       if(extraText.length > 1){
    //         if(this.simpleExplanation){
    //           let text = this.item.alternateDescs[x-1].noob
    //           let start = text.indexOf("!-")
    //           let end = text.lastIndexOf("-!")
    //           let code = text.substring(start+2, end)
    //           code = eval(code)
    //           extraText[0] = text.substring(0,start) + code + text.substring(end+2)
    //         }else{
    //           extraText[0] = this.item.alternateDescs[x-1].detailed
    //         }
    //         rebuilt += extraText[0] + extraText[1]
    //       }else{
    //          rebuilt += textArr[x]
    //       }
                   
    //     }
    //     return rebuilt
    //   }else{
    //     return text
    //   }     
    // },
    color(rarity){
      if(rarity){
        if(rarity =="common") return "grey lighten-1"
        else if(rarity =="rare") return "blue darken-2"
        else if(rarity =="epic") return "purple darken-3"
        else if(rarity =="legendary") return "orange darken-4"
        else if(rarity =="unique") return "red darken-1"
        else if(rarity =="forbidden") return "black"
        else if(rarity =="class") return "cyan"
        else return "white"
      }
    },
    backColor(rarity){
      let color = ""
      if(rarity =="common") color = "grey"
        else if(rarity =="rare") color = "blue"
        else if(rarity =="epic") color = "purple"
        else if(rarity =="legendary") color = "gold"
        else if(rarity =="unique") color = "red"
        else if(rarity =="forbidden") color = "black"
        else if(rarity =="class") color = "light_blue"
        else color = "white"
        return "Background_" + color +".png"
    },
    borderColor(item){
      // if(item.school){
      //   let arr = {"blackSeraph":"#000000","brokenBlade":"#8E6800","brutalCrocodile":"#007A0E","cursedRazor":"#74007C","elementalFlux":"#00FFFF","eternalGuardian": "#0C0093", "goldenLion":"#daa520","ironTortoise": "#333333", "mithralCurrent":"#92abbe"}
      // }else{
        let rarity = item.rarity
        if(rarity){
          if(rarity =="common") return "rgb(40,39,40)"
          else if(rarity =="rare") return "rgb(13,20,27)"
          else if(rarity =="epic") return "rgb(43,17,53)"
          else if(rarity =="legendary") return "rgb(40,25,0)"
          else if(rarity =="unique") return "rgb(32,17,14)"
          else if(rarity =="class") return "rgb(19,32,34)" 
          else return "rgb(144,144,144)"
        }
      //} 
      return "rgb(144,144,144)"
    },

    textColor(rarity){
      if(rarity){
        //if(rarity =="legendary" || rarity =="unique" ) return "#FFFFFF"
        if( rarity =="none") return "#000000"
        else if(rarity !="none") return "#FFFFFF"
      }
      return "#000000"      
    },

    createDefault(){
      if(this.item.uiType == "weapon" && !this.item.statsForAbilities){
        this.statsForAbilities.atkStat = this.item.class == "ranged" ? "dexterity" : "strength"
        let weaponDB = weapons.find(weapon=> weapon.name == this.item.name)
        if(weaponDB){
          if(weaponDB.weaponTags && weaponDB.weaponTags.includes("non-strength")){
            this.statsForAbilities.dmgStat = "none"
          }else if(weaponDB.type == "armament"){
            this.statsForAbilities.dmgStat = "intelligence"
          }else{
            this.statsForAbilities.dmgStat = "strength"
          }
          this.statsForAbilities.dieSteps = 0
          this.item.statsForAbilities = this.statsForAbilities
        }else{
          this.statsForAbilities.atkStat = "strength"
          this.statsForAbilities.dmgStat = "strength"
        }
      }else if(this.item.uiType == "weapon" && this.item.statsForAbilities){
        this.statsForAbilities = this.item.statsForAbilities
      }else if(this.item.uiType == "spells" || this.item.uiType == "maneuver"){
        let defaults = Object.keys(this.item)
        if(!defaults.includes("favorite")){
          this.item.favorite = false; 
          this.$emit("reset", this.item)
        } 
        if(!defaults.includes("expended")){
          this.item.expended = false;
          this.$emit("reset", this.item)
        }
        if(this.item.school =="radiantDawn" && isNaN(this.item.investedEssence)){
          this.item.investedEssence = 0
          this.$emit("reset", this.item)
        } 
      }else if(this.item.uiType == "feats" && this.item.givesEssence && isNaN(this.item.investedEssence)){
        this.item.investedEssence = 0
        this.$emit("reset", this.item)
      }
    },

    getDamageString(modifier,hand){
      let damageString = this.item.damage
      if(this.item.statsForAbilities.dieSteps != 0){
        let diceIndex = diceSteps.findIndex(dice=>{
          return dice.includes(damageString)                
        })
        let step = parseInt(diceIndex) + parseInt(this.item.statsForAbilities.dieSteps)
        if(step < 0) step = 0
        if(step >= diceSteps.length){
          let overSteps = step - 23
          let dieCount = 32
          let dieSize = 6
          let double = 0
          for(let x = overSteps; x > 0; x--){
            if(dieSize == 8){
              if(double != 0){
                dieCount += double
                double = 0
              }else{
                double = dieCount/2
                dieCount += double
              }
              dieSize = 6
            }else{
              dieSize = 8
            }
          }          
          damageString = dieCount + "d" + dieSize
        }else{
          damageString = diceSteps[step]
          if(damageString.includes(",")){
            damageString = damageString.split(",")[0]
          }
        }
      }
      let extraDamageCount = {d6:0,d2:0,d4:0}
      this.item.enchantments.forEach(enchantment => {
        if(enchantment.name.substring(0, 1) == "+"){          
          modifier += parseInt(enchantment.name.substring(1,2))
        }
        if(enchantment.damageMod){          
          extraDamageCount[enchantment.damageMod.substring(1,3)] += parseInt(enchantment.damageMod.substring(0,1))
        }
        if((enchantment.name == "Mighty" && this.item.statsForAbilities.dmgStat == "strength") || enchantment.name == "Tuned"){
          let abilityMod = Math.floor((this.character.modifiedStats[this.item.statsForAbilities.dmgStat]-10)/2)
          if(hand == "two") modifier += Math.floor(abilityMod * 0.75)
          else if(hand == "one") modifier += Math.floor(abilityMod * 0.5)
          else if(hand == "off") modifier += Math.floor(abilityMod * 0.25)
          
        } 
      })
      Object.keys(extraDamageCount).forEach(damage=>{
        if(extraDamageCount[damage] > 0){
          damageString += " + " + extraDamageCount[damage] + "" + damage + " "
        }
      })      
      return damageString + " + " + modifier
    },

    toggleHide(){
      this.$emit('hideItem', this.item)
    },
    toggleReady(){
      this.$emit("toggleReady", this.item)
    },
    toggleFavorite(){
      this.$emit("toggleFavorite", this.item)
    },
    reset(){
      this.$emit("toggleFavorite", this.item)
    },
    emitButtonMethod(buttonMethod){
      this.$emit("buttonMethod", this.item, buttonMethod)
    },
  },
  watch:{
    weaponModifiers(){
      if(this.weaponModifiers == false){
        if(!parseInt(this.statsForAbilities.bonusAtk)){
          this.statsForAbilities.bonusAtk = 0
        }
        if(!this.statNames.includes(this.statsForAbilities.atkStat)){
         this.statsForAbilities.atkStat = this.item.class == "ranged" ? "dexterity" : "strength"
        }      
        if(!parseInt(this.statsForAbilities.bonusDmg)){
          this.statsForAbilities.bonusDmg = 0
        }
        if(!this.statNames.includes(this.statsForAbilities.dmgStat)){
          let weaponDB = weapons.find(weapon=> weapon.name == this.item.name)
          if(weaponDB){
            if(weaponDB.weaponTags && weaponDB.weaponTags.includes("non-strength")){
              this.statsForAbilities.dmgStat = "none"
            }else if(weaponDB.type == "armament"){
              this.statsForAbilities.dmgStat = "intelligence"
            }else{
              this.statsForAbilities.dmgStat = "strength"
            }
          }
        }
        this.item.statsForAbilities = this.statsForAbilities    
      }
      this.$emit("sendCharacter")
    },
    'item.id': function(){
      this.createDefault()
    },
  }
};
</script>
<style>
.cardback .v-image__image{
  background-repeat:repeat-y; 
  background-size:auto;
  background-size:cover;
  height:100%;
}
.v-tooltip__content {
  opacity: 1.1 !important;
  background-color:rgb(97,97,97,1)!important;
}
</style>
